import { Text } from '@dropbox/dig-components/typography';
import { Box, Stack } from '@dropbox/dig-foundations';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  AttachmentSlot,
  MAX_FILE_SIZE_MB,
  SUPPORTED_EXTENSIONS,
} from 'signer-app/parts/attachments/attachment-slot';
import { useSignerContext } from 'signer-app/signer-experience/signer-experience';

export function AttachmentsDrawerContent() {
  const { attachmentSlots } = useSignerContext();

  const requiredAttachmentsCount = attachmentSlots.filter(
    (slot) => slot.required,
  ).length;

  const optionalAttachmentsCount =
    attachmentSlots.length - requiredAttachmentsCount;

  return (
    <Stack paddingX="20">
      <Box
        borderBottom="Solid"
        paddingY="20"
        borderColor="Border Subtle - On Base"
      >
        <Text tagName="p">
          {requiredAttachmentsCount > 0 && optionalAttachmentsCount > 0 && (
            <FormattedMessage
              id="92f1dc3b645420c76ba835485e719919f35c42ce83bc41fc30a332ed23d16086"
              description="text in signer flow of attachment page, informing signer that sender has requested documents to be attached with the signature request"
              defaultMessage="Sender has requested {requiredAttachmentsCount, number} {requiredAttachmentsCount, plural, =1 {required} other {required}} and {optionalAttachmentsCount, number} {optionalAttachmentsCount, plural, =1 {optional attachment} other {optional attachments}}."
              values={{
                requiredAttachmentsCount,
                optionalAttachmentsCount,
              }}
            />
          )}
          {requiredAttachmentsCount > 0 && optionalAttachmentsCount === 0 && (
            <FormattedMessage
              id="2ed9f58c9daf617b91d455c3846a111da81797b2e688b6223fd3784b49c4c360"
              description="text in signer flow of attachment page, informing signer that sender has requested documents to be attached with the signature request"
              defaultMessage="Sender has requested {requiredAttachmentsCount, number} {requiredAttachmentsCount, plural, =1 {required attachment} other {required attachments}}."
              values={{
                requiredAttachmentsCount,
              }}
            />
          )}
          {requiredAttachmentsCount === 0 && optionalAttachmentsCount > 0 && (
            <FormattedMessage
              id="7697214c211f6273def2a38f31c1ed8bf4fde71000552f6bbd654a55a3e9a93f"
              description="text in signer flow of attachment page, informing signer that sender has requested documents to be attached with the signature request"
              defaultMessage="Sender has requested {optionalAttachmentsCount, number} {optionalAttachmentsCount, plural, =1 {optional attachment} other {optional attachments}}."
              values={{
                optionalAttachmentsCount,
              }}
            />
          )}
        </Text>
        <Text color="subtle" tagName="p">
          <FormattedMessage
            id="bafa3d54fcd39420a05a3147a266b9835005bf14db1d01195f2d01482d810637"
            description="text in signer flow of attachment page, informing signer that sender has requested documents to be attached with the signature request"
            defaultMessage="Acceptable file formats: {fileFormats}"
            values={{
              fileFormats: SUPPORTED_EXTENSIONS.map((ext) => `.${ext}`).join(
                ', ',
              ),
            }}
          />
          <br />
          <FormattedMessage
            id="6464c0a53fe878fc55f2205de5682033483d54906eef739c10af846c3b02ecce"
            description="text in signer flow of attachment page, informing signer that sender has requested documents to be attached with the signature request"
            defaultMessage="Max file size: {maxSize}MB"
            values={{
              maxSize: MAX_FILE_SIZE_MB,
            }}
          />
        </Text>
      </Box>
      {attachmentSlots.map((attachment) => (
        <AttachmentSlot key={attachment.id} attachment={attachment} />
      ))}
    </Stack>
  );
}
